import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/layout/footer/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NewHeader"] */ "/app/src/components/layout/header/new-header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSlotProvider"] */ "/app/src/context/header-slot-context.tsx");
